

















import { Component, Vue } from "vue-property-decorator";

@Component
export default class PracticeBar extends Vue {
  exitRoom() {
    if (window.confirm("Are you sure you want to leave the room?")) {
      this.$router.replace({ name: "Main" });
    }
  }
}
